<script lang="ts" setup>
// import { Fancybox } from '@fancyapps/ui'
// import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js'
// import ru from '@fancyapps/ui/dist/fancybox/l10n/ru.esm.js'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import type { userSlideType } from '@fancyapps/ui/types/Carousel/types'

import ImageType from '~/enums/image-type'
import helpers from '~/helpers'

type CarouselSlide = {
  type: 'image' | 'video'
  url: string
}

type Video = {
  thumbnailUrl: string
  url: string
}

const props = defineProps<{
  galleriesData: any[]
  imagesData: any[]
  productName: string | null
  videos: Video[]
}>()

const imageTypesForGallery = [
  ImageType.Original,
  ImageType.Thumbnail480p,
  ImageType.Thumbnail360p,
  ImageType.Thumbnail240p
]
const imageTypesForSlider = [
  ImageType.Thumbnail480p,
  ImageType.Thumbnail360p,
  ImageType.Thumbnail240p,
  ImageType.Original
]

let Fancybox: any

onMounted(async (): Promise<void> => {
  const { Fancybox: FancyboxModule } = await import('@fancyapps/ui')
  Fancybox = FancyboxModule
})

const fancyboxSlides = computed(() => [
  ...imageUrls.value.map(
    (x: object): userSlideType => ({
      src: helpers.getImageUrl(x, imageTypesForGallery),
      thumb: helpers.getImageUrl(x, imageTypesForSlider),
      type: 'image'
    } as userSlideType)
  ),
  ...props.videos.map(
    (x: Video): userSlideType => ({
      src: x.url,
      thumb: x.thumbnailUrl,
      type: 'html5video'
    } as userSlideType)
  )
])
const imageUrls = computed(() => {
  const mainImageUrls = helpers.getImageUrls(props.imagesData)
  const imageUrls = []

  if (mainImageUrls) {
    imageUrls.push(mainImageUrls)
  }

  for (const galleryData of props.galleriesData) {
    const galleryImageUrls = helpers.getImageUrls(galleryData.relationships.images.data)

    if (galleryImageUrls) {
      imageUrls.push(galleryImageUrls)
    }
  }

  return imageUrls
})
const carouselSlides = computed(() => [
  ...imageUrls.value.map(
    (x: object): CarouselSlide => ({ type: 'image', url: helpers.getImageUrl(x, imageTypesForSlider) })
  ),
  ...props.videos.map((x: Video): CarouselSlide => ({ type: 'video', url: x.thumbnailUrl }))
])

function showGalleryModalWindow (startIndex: number, isVideo: boolean): void {
  Fancybox.show(
    fancyboxSlides.value,
    {
      Carousel: { infinite: false },
      Html: { videoAutoplay: isVideo },
      Thumbs: { type: 'classic' },
      Toolbar: { display: { left: [], middle: ['infobar'], right: [] } },
      closeButton: true,
      compact: false,
      idle: false,
      // l10n: ru,
      showClass: false,
      startIndex,
      hideClass: false
    }
  )
}
</script>

<template>
  <div>
    <Carousel class="z-[1]" show-dots>
      <div class="flex h-[300px]">
        <div
          v-for="({ type, url }, i) in carouselSlides"
          :key="i"
          class="h-[300px] flex-[0_0_100%] cursor-pointer bg-white pl-2 md:pl-4"
          :class="type"
          @click="showGalleryModalWindow(i, type === 'video')"
        >
          <img v-lazy="url" :alt="productName" class="size-full object-contain" loading="lazy">
        </div>
      </div>
    </Carousel>

    <div class="absolute left-0 top-0 size-full">
      <slot name="overlay" />
    </div>
  </div>
</template>
